// Intent: [Lead Gen] [SEO/GEO] [Journey]
import React from "react";
import { ArrowRightIcon, BookOpenCheckIcon, RulerIcon, ShoppingCartIcon, WrenchIcon } from "lucide-react";
import { ButtonLink } from "../components/shared/ButtonLink";
import { PageHero } from "../components/shared/PageHero";
const guides = [{
  title: "Design and Order",
  copy: "Watch how common cabinet types are configured in Cabinetry.Online.",
  href: "/guides/design-and-order/",
  action: "Watch ordering videos",
  icon: ShoppingCartIcon,
  featured: true
}, {
  title: "Assembly and Installation",
  copy: "Find step-by-step videos for cabinets, doors, drawers and components.",
  href: "/guides/assembly-and-installation/",
  action: "Watch assembly videos",
  icon: WrenchIcon,
  featured: true
}, {
  title: "Measure Before You Start",
  copy: "Prepare room, opening, service and appliance information before creating a job.",
  href: "/help/",
  action: "Review what to prepare",
  icon: RulerIcon,
  featured: false
}, {
  title: "Online Ordering Checklist",
  copy: "Check project information and available selections before submitting the job.",
  href: "/how-it-works/",
  action: "See the ordering process",
  icon: BookOpenCheckIcon,
  featured: false
}] as const;
function GuidesPage() {
  return <main id="main-content" data-id="element-333" data-mp="3w3a60oqr6fp">
      <PageHero eyebrow="Video guides" title="Start with the guide that matches your next step." copy="Watch how to configure, assemble and prepare cabinetry without searching through one large resource library." data-id="element-334" data-mp="3yz7bmsrlr33">
        <ButtonLink href="#guide-library" data-id="element-335" data-mp="3w0fccn4vdd6p">View Guides</ButtonLink>
      </PageHero>
      <section id="guide-library" className="section-shell scroll-mt-24 bg-[#eceae4]" data-id="element-336" data-mp="3w28i807nrtdn">
        <div className="container-shell grid gap-4 sm:grid-cols-2" data-id="element-337" data-mp="3h9epve7afirk">
          {guides.map(({
          title,
          copy,
          href,
          action,
          icon: Icon,
          featured
        }) => <article key={title} className={`flex min-h-[260px] flex-col rounded-xl border p-6 md:p-7 ${featured ? "border-pfpc-navy bg-pfpc-navy text-pfpc-offwhite" : "border-pfpc-navy/15 bg-pfpc-offwhite text-pfpc-navy"}`} data-id="element-338" data-mp="38akwdwp978i8">
              <Icon className={`h-7 w-7 ${featured ? "text-pfpc-orange" : "text-pfpc-steel"}`} strokeWidth={1.8} data-id="element-339" data-mp="1iva8bwinalr0" />
              <h2 className="mt-7 font-heading text-[22px] font-extrabold" data-id="element-340" data-mp="1e1o66ya3y09g">{title}</h2>
              <p className={`mt-3 max-w-[48ch] text-[15px] leading-6 ${featured ? "text-pfpc-offwhite/70" : "text-pfpc-navy/65"}`} data-id="element-341" data-mp="194fjqlhxfa2e">{copy}</p>
              <a href={href} className={`mt-auto inline-flex min-h-11 items-center gap-2 pt-5 text-[14px] font-bold underline decoration-pfpc-orange underline-offset-4 ${featured ? "text-pfpc-offwhite" : "text-pfpc-navy"}`} data-id="element-342" data-mp="21sjqlac8ht6o">{action}<ArrowRightIcon className="h-4 w-4" data-id="element-343" data-mp="1rtuk0dpsfv5q" /></a>
            </article>)}
        </div>
      </section>
      <section className="bg-pfpc-navy py-9 text-pfpc-offwhite" data-id="element-344" data-mp="1nrqx8sxo5455"><div className="container-shell flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-345" data-mp="gf8nxu9uwyku"><div data-id="element-346" data-mp="cdn41oywnk15"><h2 className="font-heading text-[26px] font-extrabold" data-id="element-347" data-mp="cdn4fq2thm1o">Still not sure where to start?</h2><p className="mt-2 text-[14px] text-pfpc-offwhite/68" data-id="element-348" data-mp="cfzu6peth0pa">Tell the PFPC team what you are trying to do.</p></div><ButtonLink href="/help/" data-id="element-349" data-mp="2s2kai8ggrobp">Get Help</ButtonLink></div></section>
    </main>;
}
export { GuidesPage };